import { atom } from 'recoil';

export const credentialsAtom = atom({
  key: 'credentialsAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});